import { embeddedBase } from "./_base";

export default embeddedBase.appendPathSegment("/fotv");